var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenedDevelopers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 167.51 231.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{stroke:url(#linear-gradient);}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3,.cls-5,.cls-9,.cls-11{fill:none;}.cls-3{stroke:url(#linear-gradient-5);}.cls-3,.cls-5,.cls-9{stroke-width:7px;}.cls-4{stroke:url(#linear-gradient-9);}.cls-4,.cls-12,.cls-7{fill:#6098fc;}.cls-13{opacity:.44;}.cls-14{fill:url(#linear-gradient-10);}.cls-12,.cls-15{opacity:.75;}.cls-5{stroke:url(#linear-gradient-4);}.cls-16{opacity:.7;}.cls-6{fill:#1e83f7;}.cls-6,.cls-8,.cls-10{stroke:#fff;}.cls-7{stroke:url(#linear-gradient-8);}.cls-17{fill:#1b1464;}.cls-8{fill:#1d94f7;}.cls-9{stroke:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-3);}.cls-10{fill:#2a77fb;}.cls-11{stroke:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 97.96,
    x2: 167.5,
    y2: 97.96,
    gradientTransform: "translate(0 179.61) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10.1,
    y1: 84.35,
    x2: 157.4,
    y2: 84.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 10.11,
    y1: 154.55,
    x2: 157.4,
    y2: 154.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 60.37,
    y1: 84.37,
    x2: 104.35,
    y2: 84.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 110.48,
    y1: 84.37,
    x2: 147.26,
    y2: 84.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 20.26,
    y1: 84.37,
    x2: 57.03,
    y2: 84.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 135.53,
    y2: 135.53,
    gradientTransform: "translate(0 -48.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 162.26,
    x2: 167.51,
    y2: 162.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 91.84,
    x2: 167.51,
    y2: 91.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 83.75,
    y1: 88.1,
    x2: 83.75,
    y2: 0,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "lime",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "lime",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167,84.35v.02h-9.6v-.02c0-2.07-32.97-3.75-73.65-3.75s-73.65,1.68-73.65,3.75v.02H.5v-.02c0-3,37.27-5.43,83.25-5.43s83.25,2.43,83.25,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.5,84.37c0-2.98,37.58-5.43,83.25-5.43s83.25,2.45,83.25,5.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 83.75,
    cy: 84.35,
    rx: 73.65,
    ry: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 83.75,
    cy: 84.35,
    rx: 73.65,
    ry: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M157.4,84.35v12.07l-68.01,68v48.61l-11.28,11.72v-60.33L10.11,96.42v-12.05c13.96,1.73,41.7,3.73,73.64,3.73s59.69-2.02,73.65-3.75Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 100.85,
    y1: 52.14,
    x2: 63.87,
    y2: 116.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "113.98 112.19 143.76 84.37 113.98 56.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "132.61 84.37 108.54 61.89 108.54 76.88 132.61 84.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "108.54 106.85 132.61 84.37 108.54 91.86 108.54 106.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "108.54 106.85 108.54 61.89 98.18 69.38 98.18 69.38 98.18 99.35 108.54 106.85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "108.54 76.88 108.54 61.89 98.18 69.38 98.18 69.38 108.54 76.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "108.54 91.86 108.54 76.88 98.18 84.37 108.54 91.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "108.54 106.85 108.54 91.86 98.18 99.35 108.54 106.85"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.54 91.86 132.61 84.37 108.54 76.88 108.54 91.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "32.11 84.37 56.18 61.89 56.18 76.88 32.11 84.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "56.18 106.85 32.11 84.37 56.18 91.86 56.18 106.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "56.18 106.85 56.18 61.89 66.54 69.38 66.55 69.38 66.55 99.35 56.18 106.85"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "56.18 76.88 56.18 61.89 66.55 69.38 66.54 69.38 56.18 76.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "56.18 91.86 56.18 76.88 66.55 84.37 56.18 91.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "56.18 106.85 56.18 91.86 66.55 99.35 56.18 106.85"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "56.18 91.86 32.11 84.37 56.18 76.88 56.18 91.86"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "53.53 112.19 23.76 84.37 53.53 56.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167,84.37c-.17,2.99-37.37,5.42-83.25,5.42S.67,87.36,.5,84.37H10.1c.21,2.06,33.1,3.73,73.65,3.73s73.44-1.67,73.65-3.73h9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M.5,84.37c0,2.98,37.58,5.43,83.25,5.43s83.25-2.45,83.25-5.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "167.01 93.88 94.4 166.49 94.4 208.53 73.11 230.63 73.11 166.49 .51 93.88 167.01 93.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.01,84.37v9.51c0,3-37.27,5.44-83.25,5.44S.51,96.88,.51,93.88v-9.51c0,2.05,17.35,3.83,42.98,4.76,11.93,.43,25.66,.68,40.27,.68s28.34-.25,40.27-.68c25.63-.93,42.98-2.71,42.98-4.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M83.75,0C43.07,0,10.1,1.68,10.1,3.75V84.35c0,2.07,32.97,3.75,73.65,3.75s73.65-1.68,73.65-3.75V3.75c0-2.07-32.97-3.75-73.65-3.75Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenedDevelopers);
export default __webpack_public_path__ + "static/media/screenedDevelopers.7bc1ba9dbe04ebaf1c1f11f04138512f.svg";
export { ForwardRef as ReactComponent };